import { Theme as ThemeResult } from '@acme/db';

 type Modifier = {
  categories: {
    category: {
      id: string;
      name: string;
    };
  }[];
  id: string;
  name: string;
  strength: number;
  verified: boolean;
  type?: 'modifier' | 'subject' | 'theme';
  enabled?: boolean;
  data?: any;
  weight?: string;
};

const getThemeModifiers = (theme: ThemeResult) => {
  const themeModifiers = theme.modifiers as Modifier[];
  const enabledThemeModifiers = themeModifiers.filter(modifier => modifier.enabled || modifier.type === 'subject');
  return enabledThemeModifiers;
};

const getSubTheme = (theme: ThemeResult) => {
  const modifiers = getThemeModifiers(theme);
  const subTheme = modifiers.find(modifier => modifier.type === 'theme')?.data as ThemeResult;
  return subTheme;
};

const getAllActiveModifiers = (theme: ThemeResult) => {
  const enabledStyles = getThemeModifiers(theme);
  const subTheme = getSubTheme(theme);

  return enabledStyles
    .map(item => {
      switch (item.type) {
        case 'modifier':
          const modifier = item as Modifier;
          return modifier;

        case 'theme':
          let modifiers = getThemeModifiers(item.data as ThemeResult);

          if (subTheme) {
            modifiers = modifiers.filter(modifier => modifier.type !== 'subject');
            const subThemeIndex = modifiers.findIndex(modifier => modifier.type === 'theme');
            const subTheme = modifiers[subThemeIndex]?.data as ThemeResult;
            const subThemeModifiers = getThemeModifiers(subTheme);
            modifiers.splice(subThemeIndex, 1, ...subThemeModifiers);
          }
          return modifiers;

        case 'subject':
          if (!subTheme)
            return {
              type: 'subject',
              data: 'subject',
              id: 'subject',
              enabled: true,
              weight: item.weight
            };

        default:
          return undefined;
      }
    })
    .filter(m => m)
    .flat() as Modifier[];
};

const getPrompt = (allActiveStyles: Modifier[], subject: string) => {
  const promptItems: string[] = [];

  allActiveStyles.forEach(style => {
    if (!style) return;
    if (style.type === 'subject') {
      promptItems.push(subject);
    } else {
      promptItems.push(style.name);
    }
  });

  return promptItems.join(', ');
};

const getNegativePrompt = (theme: ThemeResult) => {
  const negativeStyles = theme.negativeModifiers as unknown as Modifier[];
  const negativePrompt = negativeStyles?.map(style => style.name).join(', ') || undefined;
  return negativePrompt;
};

export const getPromptFromTheme = (theme: ThemeResult, subject: string) => {
  const activeModifiers = getAllActiveModifiers(theme);

  let prompt = getPrompt(activeModifiers, subject);
  const negativePrompt = getNegativePrompt(theme) || '';

  //Remove comma code
  // prompt = prompt
  //   .split(', ')
  //   .filter(item => item.length)
  //   .map(item => item.trim())
  //   .join(' ');

  return { prompt, negativePrompt };
};
